export enum ParametrosEnum {
  ACTUALIZACION_USDT = 'ACTUALIZACION_USDT',
  VALOR_SOLVENCIA = 'VALOR_SOLVENCIA',
  VALOR_LIQUIDEZ = 'VALOR_LIQUIDEZ',
  VALOR_SOLVENCIA_FIAT = 'VALOR_SOLVENCIA_FIAT',
  VALOR_LIQUIDEZ_FIAT = 'VALOR_LIQUIDEZ_FIAT',
  DESCUENTO_1 = 'DESCUENTO_1',
  DESCUENTO_2 = 'DESCUENTO_2',
  VALOR_SOLVENCIA_SELL = 'VALOR_SOLVENCIA_SELL',
  VALOR_LIQUIDEZ_SELL = 'VALOR_LIQUIDEZ_SELL',
  DESCUENTO_1_SELL = 'DESCUENTO_1_SELL',
  DESCUENTO_2_SELL = 'DESCUENTO_2_SELL',
  ACTUALIZACION_VES = 'ACTUALIZACION_VES',
  CORREOS_AUT = 'CORREOS_AUT',
  PRECIO_SPOT = 'PRECIO_SPOT',
  DESCUENTO_FIAT = 'DESCUENTO_FIAT',
  PORC_VENTA_ZELLE = 'PORC_VENTA_ZELLE',
  DESCUENTO_COM_ZELLE = 'DESCUENTO_COM_ZELLE',
  PAUSA_OPERACIONAL = 'PAUSA_OPERACIONAL',
  FOLIOS_AGUACATE = 'FOLIOS_AGUACATE',
  FOLIOS_PARRA = 'FOLIOS_PARRA',
  FOLIOS_FABRICA_ROSA = 'FOLIOS_FABRICA_ROSA',
  FACTOR_MANUAL = 'FACTOR_MANUAL',
  FOLIOS_AGUACATE_TECH = 'FOLIOS_AGUACATE_TECH',
  VALOR_SOLVENCIA_MAXIMA_FIAT = 'VALOR_SOLVENCIA_MAXIMA_FIAT',
  SETUP = 'SETUP',
  PAGO_MOVIL_BANESCO = 'PAGO_MOVIL_BANESCO',
  PAGO_MOVIL_GLOBAL = 'PAGO_MOVIL_GLOBAL',
  PAGO_MOVIL_MONTO_MAX = 'PAGO_MOVIL_MONTO_MAX',
}

/**
 * Límite máximo (en Bs) para enviar por Pago Móvil cuando el parámetro
 * PAGO_MOVIL_MONTO_MAX no está configurado en el backend.
 */
export const PAGO_MOVIL_MONTO_MAX_DEFAULT = 100000;
